import { useNavigate } from "react-router-dom";

/* CSS */
import styles from "./style/statDetails.module.css";

const TripsPlannedDetail = ({ trips }) => {
    const navigate = useNavigate();

    if (!trips || !trips.length) {
        return (
            <div className={styles.empty}>
                No trips planned yet
            </div>
        )
    }

    return (
        <div className={styles.list}>
            {trips.map((trip) => (
                <div key={trip.id} className={styles.tripRow}>
                    <div className={styles.rowMain}>
                        <div className={styles.rowTitle}>{trip.title}</div>
                        <div className={styles.rowSub}>{trip.rangeLabel}</div>
                    </div>
                    <button
                        type="button"
                        className={styles.openTripBtn}
                        onClick={() => navigate(`/trip/${trip.id}`)}
                        aria-label={`Open ${trip.title}`}
                    >
                        Open trip <span aria-hidden="true" style={{ "paddingBottom": "2px" }}>↗</span>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default TripsPlannedDetail;